function NotFound() {
    return (
      <div className="not-found">
        <h2>Not Found</h2>
      </div>
    );
  }
  
  export default NotFound;
  